import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" id=\"right\"><path fill-rule=\"evenodd\" d=\"M5.6 6L.8 10.8 2 12l6-6-6-6L.8 1.2 5.6 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron/right.svg
// module id = ./src/assets/icons/chevron/right.svg
// module chunks = 2